export const QUERY_KEYS = {
  GET_MY_DETAILS: "user:me:details",
  GET_MY_ACCOUNT_OVERVIEW: "user:me:overview",
  GET_MY_PERMISSIONS: "user:me:permissions",
  GET_MY_PROJECTS: "user:me:projects",
  SEARCH_MINE: "user:me:search",
  GET_PROJECT_BY_ID: "project:id",
  GET_MY_PERMISSIONS_IN_PROJECT: "project:id:members:me:permissions",
  GET_PROJECT_SUMMARY: "project:id:summary",
  GET_PROJECT_MEMBERS: "project:id:members",
  GET_PROJECT_ROLES: "roles:project",
  GET_PROJECT_INVITATIONS: "project:id:invitations",
  GET_MY_NOTIFICATIONS: "user:me:notifications",
  GET_PROJECT_TICKETS: "project:id:tickets",
  GET_PROJECT_TAGS: "project:id:tags",
  GET_TICKET_BY_ID: "project:id:tickets:id",
  GET_TICKET_HISTORY: "project:id:tickets:id:history",
  GET_TICKET_COMMENTS: "project:id:tickets:id:comments",
} as const;

export const QUERY_EXPIRATIONS = {
  GET_MY_DETAILS: 1000 * 60 * 3,
  GET_MY_ACCOUNT_OVERVIEW: 1000 * 60 * 3,
  GET_MY_PERMISSIONS: 1000 * 60 * 3,
  GET_MY_PROJECTS: 1000 * 60 * 3,
  SEARCH_MINE: 1000 * 60 * 1,
  GET_PROJECT_BY_ID: 1000 * 60 * 3,
  GET_MY_PERMISSIONS_IN_PROJECT: 1000 * 60 * 3,
  GET_PROJECT_SUMMARY: 1000 * 60 * 3,
  GET_PROJECT_MEMBERS: 1000 * 60 * 3,
  GET_PROJECT_ROLES: 1000 * 60 * 10,
  GET_PROJECT_INVITATIONS: 1000 * 60 * 3,
  GET_MY_NOTIFICATIONS: 1000 * 60 * 1,
  GET_PROJECT_TICKETS: 1000 * 60 * 3,
  GET_PROJECT_TAGS: 1000 * 60 * 3,
  GET_TICKET_BY_ID: 1000 * 60 * 3,
  GET_TICKET_HISTORY: 1000 * 60 * 3,
  GET_TICKET_COMMENTS: 1000 * 60 * 1,
} as const;
